export enum PaymentGuideType {
  AVAL_PAY_CENTER = 'AVAL_PAY_CENTER',
  PHYSICAL = 'PHYSICAL',
}

const paymentGuideLabels: Record<PaymentGuideType, string> = {
  AVAL_PAY_CENTER: 'AvalPayCenter',
  PHYSICAL: 'canal físico',
};
export const getPaymentGuideLabel = (type: PaymentGuideType) => paymentGuideLabels[type] || type;
